import io from 'socket.io-client';
import { SOCKET_URL } from '@/config';
import Axios from 'axios';
import store from '../store';

var socket = null;

export function setSocket() {
  socket = io(SOCKET_URL, { query: {} });
}

export function getSocket() {
  return socket;
}

export const fuelServices = [
  { value: 1, label: 'POAS', type: 0 },
  { value: 2, label: 'AYTEMIZ', type: 0 },
  // { value: 3, label:'TOTAL', type: 0},
  { value: 4, label: 'OPET', type: 0 },
  { value: 5, label: 'POINT', type: 0 },
  { value: 6, label: 'KADOIL', type: 0 },
  { value: 7, label: 'ISTANBUL ENERJI', type: 0 },
];

export function getSystemSettings() {
  let username = store.getters.user && store.getters.user.profile ? store.getters.user.profile.username : false;
  let domain = window.location.origin + '/';
  // console.log(`this.$store.getters.user`, this.$store.getters.DOMAIN)
  if (store.getters.STORAGE_DOMAIN) {
    domain = store.getters.STORAGE_DOMAIN;
  }

  Axios.post(`${domain}api/auth/system_information`, { app_name: 'SmartPole', username: username }).then(response => {
    if (response.status) {
      if (response.data && response.data.header_logo) {
        const favicon = document.getElementById('favicon');
        favicon.href = `${store.getters.STORAGE_DOMAIN}${response.data.header_logo}`;
      }
      store.commit('setSettings', response.data);
      store.commit('setPermission', response.data.permissions);
    }
  });
}
